// @flow
import type {AbstractComponent, Node} from 'react'
import React, {Component, Fragment} from 'react'
import {createFragmentContainer, graphql} from 'react-relay'
import type {$RelayProps} from 'react-relay'

import NewEditModal from 'components/ui/NewEditModal'
import Builder from 'components/proposals/Builder'
import Delete from 'components/proposals/controls/Delete'
import ProposeNowContainer from 'components/pages/Proposals/ProposeNowContainer'
import type {Organization, Proposal} from './types'

type Props = {|
  proposal: Proposal,
  organization: Organization,
  toggle: () => Promise<void>,
  noDeleteConfig: boolean,
|}

class Modal extends Component<Props> {
  static defaultProps: { noDeleteConfig: boolean } = {
    noDeleteConfig: false,
  }

  saveAndClose: (() => Promise<void>) = (): Promise<void> => (
    Promise.resolve()
      .then(this.props.toggle)
  )

  leftBlock: (() => Node) = () => (
    <Delete
      buttonTag="button"
      onSuccess={this.props.toggle}
      proposal={this.props.proposal}
      className="btn btn-secondary btn-lg"
      noDeleteConfig={this.props.noDeleteConfig}
    />
  )

  extraButton: ((saveButton: Node) => Node) = (saveButton: Node) => (
    <Fragment>
      <ProposeNowContainer proposal={this.props.proposal} toggle={this.props.toggle} />
      {saveButton}
    </Fragment>
  )

  toggleModal: (() => void) = () => {
    this.props.toggle()
  }

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Node) = () => (
    <NewEditModal
      isOpen
      keyboard={false}
      leftBlock={this.leftBlock}
      save={this.saveAndClose}
      saveTitle={I18n.t('proposals.rewrite.save')}
      size="wide"
      title={I18n.t('proposals.rewrite.edit_proposal')}
      toggle={this.toggleModal}
      extraButton={this.extraButton}
    >
      <div className="proposal-builder-modal-body test-proposal-builder-modal-body">
        <Builder
          isHost
          meeting={null}
          proposal={this.props.proposal}
          organization={this.props.organization}
        />
      </div>
    </NewEditModal>
  )
}

export default (createFragmentContainer(Modal, {
  proposal: graphql`
    fragment Modal_proposal on Proposal {
      databaseId
      status
      expectedResponseCount
      reviewStatus

      changes(first: 100) @connection(key: "ChangeList_changes") {
        edges {
          node {
            databaseId
          }
        }
      }

      tension {
        databaseId
        agendaLabel
        meetingType
      }

      ...Builder_proposal
      ...Delete_proposal
      ...ProposeNowContainer_proposal
    }
  `,
}): AbstractComponent<$RelayProps<React$ElementConfig<typeof Modal>>, Modal>)
